import { BULK_MANAGEMENT_FORM_TYPE } from 'app/constants/bulkManagement'
import i18next from 'i18next'

export const getSwitchProTrackPath = (path: string) => `${path}/switch`
export const getHistoryManagedProTracksPath = (path: string) => `${path}/history`
export const getStopProTrackPath = (path: string) => `${path}/stop`
export const getDeleteUsersPath = (path: string) => `${path}/delete`

export const getTabLinks = (path: string, isSuperAdmin: boolean) => [
  {
    path: getSwitchProTrackPath(path),
    name: i18next.t('Switch ProTracks'),
  },
  {
    path: getHistoryManagedProTracksPath(path),
    name: i18next.t('History Switched ProTracks'),
  },
  {
    path: getStopProTrackPath(path),
    name: i18next.t('Stop ProTracks'),
  },
  ...(isSuperAdmin
    ? [
        {
          path: getDeleteUsersPath(path),
          name: i18next.t('Delete Users'),
        },
      ]
    : []),
]

export const getFormTitle = (formType: BULK_MANAGEMENT_FORM_TYPE) =>
  formType === BULK_MANAGEMENT_FORM_TYPE.SWITCH_PROTRACK
    ? i18next.t(
        'admin:Select the users you would like to move and the track you would like to switch them to.The switch will happen immediately.Best after 9pm user time.'
      )
    : formType === BULK_MANAGEMENT_FORM_TYPE.STOP_PROTRACK
    ? i18next.t('admin:Select the users whom you would like to stop ProHabits for')
    : i18next.t('admin:Select the users whom you would like to delete from ProHabits')

export const getFormActionButtonLabel = (formType: BULK_MANAGEMENT_FORM_TYPE) =>
  formType === BULK_MANAGEMENT_FORM_TYPE.SWITCH_PROTRACK
    ? i18next.t('user:Switch ProTrack')
    : formType === BULK_MANAGEMENT_FORM_TYPE.STOP_PROTRACK
    ? i18next.t('admin:Stop ProTracks')
    : i18next.t('admin:Delete Users')

export const getManageUsersUrl = (formType: BULK_MANAGEMENT_FORM_TYPE, organizationId: number) =>
  formType === BULK_MANAGEMENT_FORM_TYPE.SWITCH_PROTRACK
    ? `/protrack-levels-progress/${organizationId}/`
    : formType === BULK_MANAGEMENT_FORM_TYPE.STOP_PROTRACK
    ? `/protrack-levels-progress/stop/${organizationId}/`
    : `/users/bulk/${organizationId}/`
